import { useTestFormSectionStyles } from './TestFormSectionStyles';
import FormSection from '../../../../../form/FormSection';

const DEFAULT = 'TestSubFormSection';
const SMALL = 'TestSmallSubFormSection';

function TestSubFormSection(props) {
    const { useTestSmallSubFormSection = false, ...rest } = props;
    const classes = useTestFormSectionStyles();

    const testSubFormSectionClass = useTestSmallSubFormSection ? SMALL : DEFAULT;

    return (
        <FormSection sectionContainerClassName={`${testSubFormSectionClass} ${classes.testSubFormSection}`} {...rest} />
    );
}

export default TestSubFormSection;
